export const WEB_VIEW_PROPERTIES = {
  AUTHENTICATION: 'webview_authentication',
  REFRESH_TOKEN: 'webview_refresh_token',
  RETURN_URL: 'webview_return_url',
} as const;

export const WEB_VIEW_MESSAGES = {
  CLOSE_WEBVIEW: 'CLOSE_WEBVIEW',
  CONTINUE_ONBOARDING: 'CONTINUE_ONBOARDING',
  SHOW_LOADER_TRUE: 'SHOW_LOADER_TRUE',
  SHOW_LOADER_FALSE: 'SHOW_LOADER_FALSE',
  TIME_OUT: 'TIME_OUT',
  HELP_CENTER: 'HELP_CENTER',
  PLAID_REDIRECTION: 'PLAID_REDIRECTION',
  OPEN_PRIVACY_POLICY: 'OPEN_PRIVACY_POLICY',
  OPEN_FRESHCHAT_WITH_RESTORE_ID: 'OPEN_FRESHCHAT_WITH_RESTORE_ID',
  OPEN_USA_PATRIOT: 'OPEN_USA_PATRIOT',
  OPEN_DEEP_LINK: 'OPEN_DEEP_LINK',
  OPEN_SPLITS: 'OPEN_SPLITS',
  PAYMENT_LINK_PAYMENT_COMPLETED: 'PAYMENT_LINK_PAYMENT_COMPLETED',
} as const;
